import types from "./types";

const setAuthorized = (isAuthorized) => ({
  type: types.SET_AUTHORIZED_FLAG,
  isAuthorized,
});

const setCurrentUser = (currentUserData) => ({
  type: types.SET_CURRENT_USER,
  currentUserData,
});

const unsetCurrentUser = () => ({
  type: types.UNSET_CURRENT_USER,
});

const setLogoutUser = () => ({
  type: types.SET_LOGOUT_USER,
});

const enableGlobalLoader = () => ({
  type: types.ENABLE_GLOBAL_LOADER,
});

const disableGlobalLoader = () => ({
  type: types.DISABLE_GLOBAL_LOADER,
});

const displaySnackbar = (snackBarParameters) => ({
  type: types.DISPLAY_SNACKBAR,
  snackBarParameters,
});

const hideSnackbar = () => ({
  type: types.HIDE_SNACKBAR,
});

const incrementSessionTime = () => ({
  type: types.INCREMENT_SESSION_TIME,
});

const setInactivityLogout = (inactivityLogout) => ({
  type: types.INACTIVITY_LOGOUT,
  inactivityLogout,
});

const setSystemInfo = (systemInfo) => ({
  type: types.SET_SYSTEM_INFO,
  systemInfo,
});

const setCalendarEventsCount = (calendarEventsCount) => ({
  type: types.SET_CALENDAR_EVENTS_COUNT,
  calendarEventsCount,
});

const setRedirectPath = (redirectPath) => ({
  type: types.SET_REDIRECT_PATH,
  redirectPath,
});

const unsetRedirectPath = () => ({
  type: types.UNSET_REDIRECT_PATH,
});

const setWcagContrast = (contrastValue) => ({
  type: types.SET_WCAG_CONTRAST,
  contrastValue,
});

const setWcagFont = (fontsValue) => ({
  type: types.SET_WCAG_FONTS,
  fontsValue,
});

const incrementGlobalReloadCounter = () => ({
  type: types.INCREMENT_RELOAD_COUNTER,
});

const setVotingNoVoteCount = (votingsNoVoteCount) => ({
  type: types.SET_VOTINGS_NO_VOTE,
  votingsNoVoteCount,
});

const setViewProperties = (viewProperties) => ({
  type: types.SET_VIEW_PROPS,
  viewProperties,
});

const resetViewProperties = () => ({
  type: types.RESET_VIEW_PROPS,
});

export default {
  setAuthorized,
  setCurrentUser,
  unsetCurrentUser,
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  hideSnackbar,
  incrementSessionTime,
  setInactivityLogout,
  setSystemInfo,
  setCalendarEventsCount,
  setRedirectPath,
  unsetRedirectPath,
  setWcagContrast,
  setWcagFont,
  incrementGlobalReloadCounter,
  setVotingNoVoteCount,
  setViewProperties,
  resetViewProperties
};
